'use client';

import type { FC, ReactNode, WheelEvent } from 'react';

interface DesktopFrameProps {
  chrome: ReactNode;
  children: ReactNode;
}

const scrollScreenOnSideWheel = (e: WheelEvent<HTMLElement>) => {
  const scroller = e.currentTarget.querySelector<HTMLElement>('[data-screen-scroll]');
  if (!scroller) return;
  if (!(e.target instanceof Element)) return;
  if (e.target.closest('[data-blocks-page-scroll]')) return;
  if (scroller.contains(e.target)) return;
  scroller.scrollBy({ top: e.deltaY, left: e.deltaX, behavior: 'auto' });
};

export const DesktopFrame: FC<DesktopFrameProps> = ({ chrome, children }) => {
  return (
    <div className="flex flex-col h-full w-full overflow-hidden bg-bg-primary pt-[calc(var(--tg-viewport-safe-area-inset-top,0px)+var(--tg-viewport-content-safe-area-inset-top,0px))]">
      {chrome}
      <div className="flex flex-1 min-h-0">
        <main
          className="flex-1 min-w-0 relative outline-none focus:outline-none focus-visible:outline-none"
          onWheel={scrollScreenOnSideWheel}
        >
          <div className="relative mx-auto h-full w-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
